import { render, staticRenderFns } from "./CurrencyInTable.html?vue&type=template&id=1516a538&scoped=true&"
import script from "./CurrencyInTable.js?vue&type=script&lang=js&"
export * from "./CurrencyInTable.js?vue&type=script&lang=js&"
import style0 from "./CurrencyInTable.scss?vue&type=style&index=0&id=1516a538&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516a538",
  null
  
)

export default component.exports